import { useState } from "react";

export default function ApiRequestExamples({ selectedApi, selectedQuery }) {
  const [activeTab, setActiveTab] = useState("curl");

  const pathParam = getPathParam(selectedQuery?.QueryCustomized?.parameterType);
  const url = `${window.location.origin}/api-rscore/v2/${selectedApi?.url}/${pathParam}`;

  const codeExamples = {
    curl: `curl -X GET \\
${url} \\
-H "Authorization: Bearer <seu-token-jwt>"`,

    javascript: `fetch("${url}", {
  method: "GET",
  headers: {
    "Authorization": "Bearer <seu-token-jwt>"
  }
})
  .then(res => res.json())
  .then(data => console.log(data));`,

    php: `$url = "${url}";
$token = "<seu-token-jwt>";

$headers = [
  "Authorization: Bearer $token"
];

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
$response = curl_exec($ch);
curl_close($ch);

echo $response;`,
  };

  function getPathParam(parameterType) {
    switch (parameterType) {
      case "CPF":
        return ":cpf";
      case "CNPJ":
        return ":cnpj";
      case "CPF/CNPJ":
        return ":cpf-ou-cnpj";
      case "PLACA":
        return ":placa";
      case "CHASSI":
        return ":chassi";
      case "MOTOR":
        return ":motor";
      case "PLACA/CHASSI":
        return ":placa-ou-chassi";
      default:
        return ":param";
    }
  }

  return (
    <section className="mb-12">
      <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
        🧪 <span>Exemplos de Requisição</span>
      </h3>

      <div className="border border-gray-200 rounded-lg shadow-sm bg-white">
        <div className="flex border-b text-sm font-medium text-gray-600 bg-gray-50 rounded-t-lg overflow-x-auto">
          {["curl", "javascript", "php"].map((lang) => (
            <button
              key={lang}
              onClick={() => setActiveTab(lang)}
              className={`px-4 py-2 capitalize transition-all ${
                activeTab === lang
                  ? "text-green-700 border-b-2 border-green-600 bg-white"
                  : "hover:text-green-700"
              }`}
            >
              {lang === "javascript" ? "JavaScript (fetch)" : lang}
            </button>
          ))}
        </div>

        <div className="p-4 bg-gray-50 text-sm">
          <pre className="text-xs font-mono text-gray-800 whitespace-pre-wrap">
            {codeExamples[activeTab]}
          </pre>
        </div>
      </div>
    </section>
  );
}
